var map = {
	"./character.png": 59,
	"./character@2x.png": 60
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 116;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img ^\.\/character.*\.png$
// module id = 116
// module chunks = d-game